import { FieldArray } from 'react-final-form-arrays';
import { FormSpy } from 'react-final-form';

import { IKnmErknmFormViolatedRequirementsMandatory } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { IKnmErknmFormRequirementNpa } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormRequirementNpa';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { IDecisionForm } from 'DecisionPackage/MainModule/interfaces/IDecisionForm';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import styles from './DecisionRepeatViolation.module.scss';
import { ViolationItem } from './ViolationItem';

interface IDecisionRepeatViolationProps {
  checkboxDisabled: boolean;
  formRef: IDecisionFormRef | undefined;
  inBody?: boolean;
}

export const DecisionRepeatViolation = ({ checkboxDisabled, formRef, inBody }: IDecisionRepeatViolationProps) => {
  const requirementsNpaFieldName = 'violatedMandatoryRequirements' as keyof IDecisionForm;

  return (
    <>
      <FormSpy subscription={{ errors: true, touched: true }}>
        {() => (
          <div className={styles.DecisionRepeatViolationNpaWrapper}>
            <FieldArray name={requirementsNpaFieldName}>
              {({ fields }) => {
                return fields.map((name, index) => {
                  const requirementNpa: IKnmErknmFormRequirementNpa = fields.value?.[index];
                  const { npa, structuralUnit } = requirementNpa;

                  if (!npa || !structuralUnit) return null;

                  return (
                    <FieldArray key={name} name={`${name}.violatedMandatory`}>
                      {({ fields: mFields }) =>
                        mFields.map((mName, mIndex) => {
                          const mandatory = mFields.value?.[mIndex] as IKnmErknmFormViolatedRequirementsMandatory;

                          if (!mandatory || !mandatory.mandatory) return null;

                          return (
                            <FieldArray key={name} name={`${mName}.violations`}>
                              {({ fields: vFields }) =>
                                vFields.map((vName, vIndex) => {
                                  const violation = vFields.value?.[vIndex] as IKnmErknmFormViolation;

                                  if (!violation) return null;

                                  return (
                                    <ViolationItem
                                      key={`${vName}-${violation.id}`}
                                      violation={violation}
                                      requirementNpa={requirementNpa}
                                      violationName={vName}
                                      checkboxDisabled={checkboxDisabled}
                                      formRef={formRef}
                                      id={`${requirementsNpaFieldName}[${requirementNpa.guid}].violatedMandatory[${mIndex}].violations[${vIndex}]`}
                                      inBody={inBody}
                                    />
                                  );
                                })
                              }
                            </FieldArray>
                          );
                        })
                      }
                    </FieldArray>
                  );
                });
              }}
            </FieldArray>
          </div>
        )}
      </FormSpy>
    </>
  );
};
